import { gql } from '@apollo/client';

export const QLayoutQuery = gql`
  query QLayoutQuery {
    layout {
      projectNumber
      offerCode
      numberPricings
      companyName
      companyTooltip
    }
  }
`;
